import { BaseContainer3D } from './base-container-3d';
import { Injectable } from '@angular/core';
import { Euler, Vector3 } from 'three';

export type PositionAndRotation = {position: Vector3, rotation: Euler}

@Injectable({ providedIn: 'root' })
export class GlobalContainer extends BaseContainer3D {

  public readonly isGlobalContainer = true;

  public resetCoordianteSystem() {
    this.moveTo(0, 0, 0);
    this.inverseRotateByEuler(this.rotation.clone());
  }
}
